import api from '@/api';
import * as dateutil from '@/util/date-helper.ts';

const convertFolderToClient = function(item: any):calendar.Folder {
    let folder: calendar.Folder = {
        ...item,
        id: item.id,
        colorCode: item.color || 'none',
        displayName: item.displayName,
        events: item.calendarEventList,
        dbType: item.type,    
    } as calendar.Folder;
    return folder;
}

const convertFolderToServer = function(item: calendar.Folder) {
    let folder: any = {
        ID: item.id,
        DisplayName: item.displayName,
        CalendarEventList: item.events,
        Type: item.dbType,
        Color: item.colorCode || 'none',
        DeptCode: item.deptCode,
        ComCode: item.comCode,
        PersonCode: item.personCode,
    };
    return folder;
}

export default {    

    getCalendarFolder(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/CalendarFolder/get?funcName=getCalendarFolder',
            data: {
                ID: item.ID,
                CalendarEventList:
                [
                    /*{
                        StartDateEnd: '2020-06-05',
                        USE_TA_CALENDAR_EVENT_BODY: true,
                    }*/
                ],
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TA_FOLDER_ATTRS: item.USE_TA_FOLDER_ATTRS || false,
				USE_TC_FOLDER_TYPE: item.USE_TC_FOLDER_TYPE || false,

            }
        }).then((res) => {
            (res as any).isEWS = false;
           return res;
        });
    },

    getAllCalendarFolder() {
        return api.post<Array<any>>({
            url: '/api/calendar/CalendarFolder/all?funcName=getAllCalendarFolder',
        }).then((res) => {
            return res.map((data, idx) => {
                let result = {
                    ...convertFolderToClient(data),
                    selected: false,
                    index: idx,
                    checked: false,
                    isEWS: false,
                };
                return result;
            });
        });
    },

    getFindCalendarFolder(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/CalendarFolder/find?funcName=getFindCalendarFolder',
            data: {
				ID: item.ID || null,
				ParentID: item.ParentID || null,
				ParentIDMin: item.ParentIDMin || null,
				ParentIDMax: item.ParentIDMax || null,
				Type: item.Type || null,
				ComCode: item.ComCode || null,
				DeptCode: item.DeptCode || null,
				PersonCode: item.PersonCode || null,
				Color: item.Color || null,
				DisplayName: item.DisplayName || null,
				IsDeleted: item.IsDeleted || null,
				EumPageNumber: item.EumPageNumber || null,
				EumRowsPerPage: item.EumRowsPerPage || null,
				EumSearchCategory: item.EumSearchCategory || null,
				EumSearchKey: item.EumSearchKey || null,
				EumNoCondition: item.EumNoCondition || null,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TC_FOLDER_TYPE: item.USE_TC_FOLDER_TYPE || false,

            }
        }).then((res) => {
            return res.map((data, idx) => {
                let result = {
                    ...convertFolderToClient(data),
                    selected: false,
                    index: idx,
                    root_index: 0,
                    checked: false,
                    isEWS: false,
                };
                return result;
            });
        });
    },

    createCalendarFolder(item: any) {
        item = convertFolderToServer(item);
        item.Color = 'none';
        return api.post<any>({
            url: '/api/calendar/CalendarFolder/create?funcName=createCalendarFolder',
            data: {
				ParentID: item.ParentID,
				Type: item.Type,
				ComCode: item.ComCode,
				DeptCode: item.DeptCode,
				PersonCode: item.PersonCode,
				Color: item.Color,
				DisplayName: item.DisplayName,
				IsDeleted: item.IsDeleted,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarEventList: item.CalendarEventList || [],
				FolderAttrs: item.FolderAttrs,
				FolderType: item.FolderType,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TA_FOLDER_ATTRS: item.USE_TA_FOLDER_ATTRS || false,
				USE_TC_FOLDER_TYPE: item.USE_TC_FOLDER_TYPE || false,

            }
        });
    },

    updateCalendarFolder(item: any) {
        item = convertFolderToServer(item);
        return api.post<any>({
            url: '/api/calendar/CalendarFolder/update?funcName=updateCalendarFolder',
            data: {
				ID: item.ID,
				ParentID: item.ParentID,
				Type: item.Type,
				ComCode: item.ComCode,
				DeptCode: item.DeptCode,
				PersonCode: item.PersonCode,
				Color: item.Color,
				DisplayName: item.DisplayName,
				IsDeleted: item.IsDeleted,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarEventList: item.CalendarEventList || [],
				FolderAttrs: item.FolderAttrs,
				FolderType: item.FolderType,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TA_FOLDER_ATTRS: item.USE_TA_FOLDER_ATTRS || false,
				USE_TC_FOLDER_TYPE: item.USE_TC_FOLDER_TYPE || false,

            }
        });
    },    

    deleteCalendarFolder(item: any) {
        item = convertFolderToServer(item);
        return api.post<any>({
            url: '/api/calendar/CalendarFolder/delete?funcName=deleteCalendarFolder',
            data: {
				ID: item.ID,
				USE_TA_CALENDAR_EVENT: item.USE_TA_CALENDAR_EVENT || false,
				USE_TA_FOLDER_ATTRS: item.USE_TA_FOLDER_ATTRS || false,
				USE_TC_FOLDER_TYPE: item.USE_TC_FOLDER_TYPE || false,
            }
        });
    },
}

